<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bkht">
<h1 class="bkht"><a class="page" id="pi"></a>Modernity and the Jews in Western Social Thought</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Goldberg-0002.vue?a39bba06